module.exports = __webpack_public_path__ + "static/media/DSC_0135.d2a9cc13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0135.jpg
// module id = 634
// module chunks = 0